// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "navigation-ui-header[data-v-6fdf30f4]{height:144px}@media screen and (max-width:1023px){navigation-ui-header[data-v-6fdf30f4]{height:56px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
